var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuildPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.24 17.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        isolation: isolate;\n        opacity: .8;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1444",
    "data-name": "Group 1444"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    className: "cls-2",
    d: "m0,4.26L13.62,0l13.62,4.26-13.62,4.25L0,4.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_83",
    "data-name": "Subtraction 83",
    className: "cls-1",
    d: "m13.62,17.02h0L0,12.77l5.42-1.69,2.36.74-3.28.96,9.12,2.66,9.12-2.66-3.28-.96,2.36-.74,5.42,1.69-13.62,4.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_82",
    "data-name": "Subtraction 82",
    className: "cls-1",
    d: "m13.62,12.77h0L0,8.51l5.42-1.69,2.36.74-3.28.96,9.12,2.66,9.12-2.66-3.28-.96,2.35-.74,5.42,1.69-13.62,4.26Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildPreview);
export default __webpack_public_path__ + "static/media/build_preview.9e552ed429f4788af3e0b6859d131d3a.svg";
export { ForwardRef as ReactComponent };